// extracted by mini-css-extract-plugin
export default {"container":"Content_container__wBIhK","heading":"Content_heading__HrsGm","grid":"Content_grid__4qwiw","item":"Content_item__e0wLk"};